var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartBrowserScaled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "sv",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 0,
    fill: "#cbfb45",
    d: "M90, 0 A90,90 0 0 1 175.5965425575103,117.80704770737674 L147.0643617050069,108.53803180491784 A60,60 0 0 0 90,30 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    fill: "#195818",
    d: "M175.5965425575103, 117.80704770737674 A90,90 0 0 1 90.00785398162398,179.9999996573054 L90.00523598774932,149.99999977153692 A60,60 0 0 0 147.0643617050069,108.53803180491784 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    fill: "#FA5757",
    d: "M90.00785398162398, 179.9999996573054 A90,90 0 0 1 4.408311991552509,117.82198669873496 L32.938874661035,108.54799113248997 A60,60 0 0 0 90.00523598774932,149.99999977153692 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    fill: "#6E8727",
    d: "M4.408311991552509, 117.82198669873496 A90,90 0 0 1 37.08789073805259,17.19678102273403 L54.72526049203506,41.46452068182269 A60,60 0 0 0 32.938874661035,108.54799113248997 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    fill: "#BBAB45",
    d: "M37.08789073805259, 17.19678102273403 A90,90 0 0 1 89.98429203681187,0.0000013707783779182137 L89.98952802454124,30.000000913852254 A60,60 0 0 0 54.72526049203506,41.46452068182269 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBrowserScaled);
export default __webpack_public_path__ + "static/media/chart_browser_scaled.e7f6e56b5c5466bc2f2570550f25f01b.svg";
export { ForwardRef as ReactComponent };